import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { connect, useSelector } from 'react-redux';
import { salary } from '../../redux/actions/filterActions';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    selectBorder: {
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#fff'
        },
    },
});

const Salary = ({ salary }) => {
    const classes = useStyles();
    const [state, setState] = useState('');
    const [loaded, setLoaded] = useState(false);
    const handleChange = (event) => {
        event.target.value = event.target.value < 0 ? (event.target.value = 0) : event.target.value;
        salary(event.target.value);
        setState(event.target.value);
        localStorage.setItem('salary', event.target.value);
    };

    const filterReducer = useSelector((state) => state.filterReducer);

    useEffect(() => {
        if (!loaded  && localStorage.getItem('salary')) {
            setLoaded(true);
            setState(localStorage.getItem('salary'));
            salary(localStorage.getItem('salary'));
            return;
        }
        if (!filterReducer.salary) {
            setState('');
        }
    }, [filterReducer.salary]);

    return (
        <TextField
            className={classes.selectBorder}
            fullWidth
            id="outlined-basic"
            label="Минимальная зарплата, в месяц"
            variant="outlined"
            type="tel"
            onChange={(event) => handleChange(event)}
            value={state}
            InputLabelProps={{
                shrink: true,
                classes: { root: classes.label }
            }}
        />
    );
}

const mapStateToProps = state => ({
    salary: state.salary,
})

export default connect(mapStateToProps, { salary, })(Salary)